import React from 'react';
import {isNil, startCase} from 'lodash';

import {Badge} from '@albert-io/atomic';
import type {BadgeStatuses as BadgeStatus} from '@albert-io/atomic/atoms/Badge/Badge.react';
import type {StudentAssignment} from './StudentAssignment.types';
import {StudentAssignmentStatus} from 'gql/types';

type AssignmentStatus = 'graded' | 'inProgress' | 'notStarted' | 'pastDue' | 'submitted';

interface Props {
  assignment: StudentAssignment;
}

const assignmentStatusToBadgeStatus = new Map<AssignmentStatus, BadgeStatus>([
  ['graded', 'neutral'],
  ['inProgress', 'info'],
  ['notStarted', 'neutral'],
  ['pastDue', 'negative'],
  ['submitted', 'positive']
]);

export default function AssignmentStatusBadge({assignment}: Props) {
  let assignmentStatus: AssignmentStatus;

  const {grade} = assignment;

  if (!isNil(grade)) {
    assignmentStatus = 'graded';
  } else if (assignment.status === StudentAssignmentStatus.Completed) {
    assignmentStatus = 'submitted';
  } else if (assignment.status === StudentAssignmentStatus.PastDue) {
    assignmentStatus = 'pastDue';
  } else if (assignment.status === StudentAssignmentStatus.InProgress) {
    assignmentStatus = 'inProgress';
  } else {
    assignmentStatus = 'notStarted';
  }

  return (
    <Badge
      emphasis={assignmentStatus === 'graded' ? 'default' : 'subtle'}
      roundness='square'
      status={assignmentStatusToBadgeStatus.get(assignmentStatus)}
    >
      {!isNil(grade)
        ? `Grade: ${grade.toLocaleString(undefined, {style: 'percent'})}`
        : startCase(assignmentStatus)}
    </Badge>
  );
}
